module.exports = __webpack_public_path__ + "img/JMMP_Website_Projects_Typefaces_03_JM-12.8ce9ede1.svg";